// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"4944fc7f08b9af5d","190":"6d2ec084a563f04e"}[chunkId] + ".css";
};